import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueSession from "vue-session";
import ReciepeAPI from "./mixins/ReciepeAPI";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

Vue.use(VueSession);
Vue.mixin(ReciepeAPI);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
